//*************************************************************************************
//* Session specific code
//*
//* 6/13/18 Kraus    [COM-136]: Created
//*************************************************************************************

app.Election = (function () {
    var myElection = {
        Index: function () {
            $("#tabs").tabs();
            $("#tabs").find('.ui-corner-top').removeClass('ui-corner-top');
            $("#gridElection").kendoGrid({
                columns: [{
                    field: "Id",
                    hidden: true
                },
                {
                    field: "ElectionTitle",
                    title: "Title"
                },
                {
                    field: "Status",
                    title: "Status"
                },
                {
                    template: "<a target='_blank' class='uw-button tiny info remove-rounded-corners' href='/Election/Details/#=Id#'>Details</a>"
                }],
                scrollable: false,
                sortable: true
            });
            app.KendoGrids.InitPersistentGrid("gridElection", true);

            $(document).on('click', '[data-role="save-election"]', function () {
                app.Election.SaveElection(this);
            });



            $("#gridScheduled").kendoGrid({
                columns: [{
                    field: "Id",
                    hidden: true
                },
                {
                    field: "ElectionId",
                    hidden: true
                },
                {
                    field: "ElectionTitle",
                    title: "Title",
                    width: "300px"
                },
                {
                    field: "ElectionStart",
                    title: "Start",
                    format: "{0:M/d/yyyy}",
                    width: "75px"

                },
                {
                    field: "ElectionEnd",
                    title: "End",
                    format: "{0:M/d/yyyy}",
                    width: "75px"

                },
                {
                    field: "Live",
                    title: "Live",
                    width: "75px",
                    template: "# if (Live != 'Yes') { #<span class='label alert'>Offline</span># } else { #<span class='label success'>Live</span> #}#"
                },
                {
                    field: "VoteCount",
                    title: "Voters",
                    width: "75px"
                },
                {
                    field: "Status",
                    title: "Status",
                    width: "75px"
                },
                {
                    template: "<a target='_blank' class='uw-button tiny info remove-rounded-corners' href='/Election/ScheduledElectionDetails/#=ElectionId#/#=Id#'>Details</a>"
                }],
                scrollable: false,
                sortable: true,
                dataSource: {
                    schema: {
                        model: {
                            fields: {
                                ElectionStart: { type: "date" },
                                ElectionEnd: { type: "date" }
                            }
                        }
                    }
                }
            });
            app.KendoGrids.InitPersistentGrid("gridScheduled", true);
        },
        SaveElection: function (button) {
            $.ajax({
                url: $(button).data('url'),
                type: 'POST',
                data: $(button).closest('form').serialize(),
                success: function (result) {
                    if (result == "Success") {
                        toastr.success("Election saved successfully!", "Save successfull");
                        $('#txtElectionTitle').val('');
                        $('#txtDescription').val('');
                        $('#pnlAddElection').hide();
                        app.KendoGrids.GetResults('gridElection');
                    } else {
                        //Was an error
                        toastr.error("Election did not save.", "Save error");
                    }
                },
                error: function (result) {
                    toastr.error("Election did not save.", "Save error");
                    //$("#dialog-error").dialog("open");
                    //$("#dialog-error").dialog(opt).dialog("open");
                    //errorDialog.dialog("open");
                    //$('#submittingCase').html('');
                }
            });
}
    };
    return myElection;
}());